module.exports = __webpack_public_path__ + "img/min-comp-title.e4bd3981.svg";